import React, { useEffect, createRef, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import InputIntl from '../InputIntl';
import {
  SliderLabel,
  SliderContainer,
  SliderInput,
  SliderContainerLabelInput,
  SliderInputReadOnly,
  SliderLabelMinMax,
  SliderInputContainer,
} from './styles';
import { currencyMoney } from '../../config/currency';
import { useForm, Controller } from 'react-hook-form';
import IntlCurrencyInput from "react-intl-currency-input";
import { formatPrice } from '../../helpers/price';

const Slider = ({ error, name, id, label, min, max,doSimulation,setValue,defaultValue, register, ...rest }) => {
  const [sliderValue, setSliderValue] = useState(2000000);
  
  const handleSliderChange = (event) => {
    const newValue = event.target.value;
    setValue(name,newValue);
    setSliderValue(newValue);
  };

  const handleInputChange = (event, value, maskedValue) => {
    const numericValue = parseFloat(maskedValue.replace(/[^0-9]/g, ''));
    setValue(name,numericValue);
    if (!isNaN(numericValue)) {
      const element = document.getElementById("slider"+id);
      if (element) {
        element.value = numericValue;
      }
      setSliderValue(numericValue);
    } else {
      setSliderValue(0);
    }
  };

  const handleRangeRelease = () => {
    doSimulation();
  };

  useEffect(() => {
    setSliderValue(defaultValue);
    setValue(name,defaultValue);
    setValue("slider"+name,defaultValue);
  },[defaultValue]);

  return (
    <SliderContainer id="slider" >
      <SliderContainerLabelInput>
        <SliderLabel>{label}</SliderLabel>
          <IntlCurrencyInput
            config={currencyMoney}
            currency={currencyMoney.currency}
            onChange={handleInputChange}
            className={error && 'error'}
            value={parseInt(sliderValue)}
            onBlur={handleRangeRelease}
            {...rest}
          />
          <input type="hidden" name={name} ref={register} id={id} />
      </SliderContainerLabelInput>
      <SliderInput type="range"  ref={register} min={min} max={max} step="10000" name={"slider"+name} id={"slider"+id} onChange={handleSliderChange} onMouseUp={handleRangeRelease}/>
      <SliderContainerLabelInput>
        <SliderLabelMinMax>|</SliderLabelMinMax>
        <SliderLabelMinMax>|</SliderLabelMinMax>
      </SliderContainerLabelInput>
      <SliderContainerLabelInput>
        <SliderLabelMinMax>${formatPrice(parseInt(min))}</SliderLabelMinMax>
        <SliderLabelMinMax>${formatPrice(parseInt(max))}</SliderLabelMinMax>
      </SliderContainerLabelInput>
    </SliderContainer>
  )
}

export default Slider
